import { faCircleExclamationCheck, faEmptySet, faSliders } from '@fortawesome/pro-light-svg-icons';
import { faFlag, faThumbsDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, IconButton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { useKanbanFilterStore, KanbanFilter } from '../../hooks/useKanbanFilterStore';

export const KanbanFilterButton = () => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan.kanban');
  const filters = useKanbanFilterStore((state) => state.kanbanFilters);
  const setKanbanFilters = useKanbanFilterStore((state) => state.setKanbanFilters);

  const handleSelectOption = (option: KanbanFilter) => (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if (filters.includes(option)) {
      setKanbanFilters(filters.filter((o) => o !== option));
    } else {
      setKanbanFilters([...filters, option]);
    }
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton
          count={filters.length}
          Icon={<FontAwesomeIcon icon={faSliders} />}
          withIndicator={filters.length > 0}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="z-25 pt-2">
        <div className="mb-2 ml-4 text-s11-sb text-text-secondary uppercase">{t('common.filterView')}</div>
        <DropdownMenu.Checkbox
          checked={filters.includes(KanbanFilter.PRIORITY)}
          onSelect={handleSelectOption(KanbanFilter.PRIORITY)}
        >
          <FontAwesomeIcon className="size-5! text-icon-brand" icon={faFlag} />
          {tWrapper('priority')}
        </DropdownMenu.Checkbox>
        <DropdownMenu.Checkbox
          checked={filters.includes(KanbanFilter.TO_ACCEPT)}
          onSelect={handleSelectOption(KanbanFilter.TO_ACCEPT)}
        >
          <FontAwesomeIcon className="size-5! text-icon-status-orange-lighter" icon={faCircleExclamationCheck} />
          {tWrapper('toAccept')}
        </DropdownMenu.Checkbox>
        <DropdownMenu.Checkbox
          checked={filters.includes(KanbanFilter.DELAYED)}
          onSelect={handleSelectOption(KanbanFilter.DELAYED)}
        >
          <FontAwesomeIcon className="size-5! text-icon-error" icon={faThumbsDown} />
          {tWrapper('isBehindSchedule')}
        </DropdownMenu.Checkbox>
        <DropdownMenu.Checkbox
          checked={filters.includes(KanbanFilter.SHOW_WITHOUT_TASKS)}
          onSelect={handleSelectOption(KanbanFilter.SHOW_WITHOUT_TASKS)}
        >
          <FontAwesomeIcon className="size-5! text-icon-primary" icon={faEmptySet} />
          {tWrapper('showWithoutTasks')}
        </DropdownMenu.Checkbox>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
